module.exports = __webpack_public_path__ + "static/media/slider-home-landing-slide-01-image-01.b81de9b0.png";